import { Component, OnInit, ViewChild } from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { ModalController, NavParams, IonicModule } from "@ionic/angular";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import * as moment from "moment";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { LeaveSyndicateComponent } from "../leave-syndicate/leave-syndicate.component";
import { PauseSyndicateComponent } from "../pause-syndicate/pause-syndicate.component";
import { SyndicateLeaveComponent } from "../syndicate-leave/syndicate-leave.component";
import { UnpauseSyndicateBottomsheetComponent } from "../unpause-syndicate-bottomsheet/unpause-syndicate-bottomsheet.component";
import { FormsModule } from "@angular/forms";
import { DatePipe } from "@angular/common";


@Component({
    selector: "app-syndicate-status",
    templateUrl: "./syndicate-status.component.html",
    styleUrls: ["./syndicate-status.component.scss"],
    standalone: true,
    imports: [
        IonicModule,
        FormsModule,
        DatePipe,
        TranslatePipe,
    ],
})
export class SyndicateStatusComponent implements OnInit {
  @ViewChild("appHeader", { static: true }) header: any;
  syndicate: any;
  pageTitle = "Syndicate’s status";
  isPausedChecked = false;
  constructor(
    private modalController: ModalController,
    private bottomSheet: MatBottomSheet,
    private navParams: NavParams,
    public translate: TranslateService,
    private GTMSegment: GTMSegmentService,
    private dialog: MatDialog

  ) {
    this.GTMSegment.GTMPopupInitialization("SyndicateStatus");
  }


  ngOnInit() {
    this.syndicate = this.navParams?.data.syndicateData;
    this.isPausedChecked = this.syndicate?.active_status === "paused" ? true : false;
    this.translate.get(['syndicate-status.pageTitle'])?.subscribe((res: string) => {
      this.pageTitle = (res["syndicate-status.pageTitle"])
    }, err => { return (err) })
  }

  goBack() {
    this.modalController.dismiss({data: 'close'}).catch(err => { return err });
  }
  getResumeDate() {
    return moment()?.add(28, "days").format("DD MMM YYYY");
  }
  onPauseToggleChange(val: any, isPausedChecked) {
    if (val === true && !isPausedChecked) {
      this.GTMSegment.HotJarEvent('user_syndicate_paused');
      this.isPausedChecked = true;
      this.openPauseSyndicate();
    } else if (!this.isPausedChecked) {
      this.GTMSegment.HotJarEvent('user_syndicate_unpaused');
      this.openUnpaused();
    }
  }

  private openPauseSyndicate() {
    const pauseSyndicateDialog = this.bottomSheet.open(PauseSyndicateComponent, {
      panelClass: "pause-syndicate-bottom-sheet",
      data: { syndicate: this.syndicate },
    });

    pauseSyndicateDialog.afterDismissed()?.subscribe((res: boolean) => {
      setTimeout(() => {
        if (!res) {
          this.isPausedChecked = false;
          this.modalController.dismiss({ data: "syndicatePaused" }).catch(err => { return err });
        } else {
          this.syndicate.syndicate_status = "paused";
          this.modalController.dismiss({ data: "syndicatePaused" }).catch(err => { return err });
        }
      }, 1000);
    }, err => { return (err) });
  }

  pauseToggle(syndicate) {
    return syndicate?.syndicate_status;
  }

  async confirmLeaveReason() {
    const leaveSyndicateReason = await this.modalController.create({
      component: LeaveSyndicateComponent,
      cssClass: "modal-fullScreen",
      componentProps: { syndicate: this.syndicate },
    });
    leaveSyndicateReason.onDidDismiss().then((res) => {
      if (res && res.data) {
        setTimeout(() => {
          this.modalController.dismiss(res?.data).catch(err => { return err });
        }, 100);
      }
    }).catch((err) => {
      return err;
    });
    return await leaveSyndicateReason?.present();
  }
  leaveSyndicateConfirmation() {
    this.GTMSegment.HotJarEvent('user_click_leave');
    const leaveSyndicateConfirmation = this.dialog.open(SyndicateLeaveComponent, {
      panelClass: "leave-syndicate-dialog",
      width: "96vh",
      position: {
        top: "18vh",
        left: "3.5vh",
      },
      backdropClass: "back-drop-color",
      data: { syndicate: this.syndicate, reason: '' },
    });
    leaveSyndicateConfirmation.afterClosed()?.subscribe(
      (res: any) => {
        if(res?.syndicate_pause_gift){
          this.syndicate.syndicate_pause_gift = res?.syndicate_pause_gift;
          this.onPauseToggleChange(true, this.syndicate?.active_status === "paused" ? true : false);
          return;
        }
        if (!res) {
          return;
        }
        if (res && res?.isSuccessLeave) {
          this.modalController.dismiss().catch((err) => {
            return err;
          });
        }
      },
      (err) => {
        return err;
      }
    );
  }
  openUnpaused() {
    const pauseSyndicateDialog = this.dialog.open(UnpauseSyndicateBottomsheetComponent, {
      panelClass: "unpause-syndicate-popup",
      data: { syndicate: this.syndicate },
    });

    pauseSyndicateDialog?.afterClosed()?.subscribe((data) => {
      if (data) {
        this.modalController.dismiss({ data: "close" });
      } else {
        this.isPausedChecked = true;
      }
    });
  }
}
